import { urlConstants } from "../../constant";
import { UserObj } from "../../services/localStarage";

export const downloadFile = async (data) => {
    let url = `${urlConstants.BASE_URI_DEV}${data?.url}`;    
    let myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${UserObj?.accessToken}`);
    myHeaders.append("Content-Type", "application/json");
    let raw = JSON.stringify(data?.bodyData);

    let requestOptions = {
        method: data?.method,
        headers: myHeaders,
        body: raw,
        redirect: "follow",
    };
    
    return fetch( url, requestOptions )
    .then( async response => {
        let contentType = response.headers.get('Content-Type');
        let contentDisposition = response.headers.get('Content-Disposition');
        let fileName = data?.fileName; // Fallback filename
        const match = contentDisposition?.match(/filename=["']?([^;"']+)["']?/);
        if (match && match[1]) {
            fileName = decodeURIComponent(match[1]);
        }

        // console.log("Download Res: ", response, contentType, contentDisposition, match, fileName);
        let resData = {contentType, fileName};
        if (contentType.includes('application/json')) {
            resData["data"] = await response.json(); // Parse JSON
            resData["dataType"] = 'application/json'; 
        } else if (contentType.includes('application/pdf')) {
            resData["data"] = await response.blob(); // Parse as pdf
            resData["dataType"] = 'blob'; 
        } else if (contentType.includes('application/image')) {
            resData["data"] = await response.blob(); // Parse as image
            resData["dataType"] = 'blob'; 
        } else if (contentType.includes('zip')) {
            resData["data"] = await response.blob(); // Parse as zip
            resData["dataType"] = 'blob'; 
        } else if (contentType.includes('application/vnd')) {
            resData["data"] = await response.blob(); // Parse as xlsx
            resData["dataType"] = 'blob'; 
        } else {            
            throw new Error('Unsupported Content-Type');
        }

        if (response.status === 400) {
            throw new Error(`${resData?.data?.message}`);
        }
        return resData;
    })
    .then(resData => {
        // console.log(resData);
        if (resData?.dataType == "blob") {
            const link = window.document.createElement('a');
            link.href = URL.createObjectURL(resData?.data,  { type: resData?.contentType });

            link.download = resData?.fileName;
            window.document.body.appendChild(link);
            link.click();
            window.document.body.removeChild(link);                
        }
        if (resData?.dataType == "application/json") {
            return resData;
        }
    })
};